let cachedConfig = null;

export const getAppConfig = async () => {
    if (cachedConfig) return cachedConfig;

    const res = await fetch("/config.json");

    if (!res.ok) {
        throw new Error("Failed to load config.json from public folder");
    }

    cachedConfig = await res.json();
    return cachedConfig;
};

export const getBaseApiUrl = async (type) => {
    const config = await getAppConfig();
    if (type === 'enquiry') {
        return config.enquiryUrl;
    }
    return config.BASE_API_URL;
};


